import { CONSTANTS } from '@tpco/tpco-saturn-types';
function capitalizeFirstCharacter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function getProductNameById(id: number) {
  let name;
  switch (id) {
    case CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS:
      name = CONSTANTS.PRODUCT_TYPE_MAP[CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS];
      break;
    case CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS:
      name = capitalizeFirstCharacter(
        CONSTANTS.PRODUCT_TYPE_MAP[CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS]
      );
      break;
    default:
      return null;
  }
  return name;
}

function getProductIdByName(string: string) {
  let productId;
  switch (string) {
    case CONSTANTS.PRODUCT_TYPE_MAP[CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS]:
      productId = CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS;
      break;
    case CONSTANTS.PRODUCT_TYPE_MAP[CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS]:
      productId = CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS;
      break;
    default:
      return null;
  }

  return productId? productId.toString(): productId;
}

function buildURL(path: string) {
  const BASE_URL_PATH = process.env.REACT_APP_BASE_URL_PATH
    ? process.env.REACT_APP_BASE_URL_PATH
    : '/';
  let url = `${BASE_URL_PATH}${path}`;
  return url.replace('//', '/').replace('configuration/configuration', 'configuration');
}

export { capitalizeFirstCharacter, getProductNameById, getProductIdByName, buildURL };
